export const transformEmail = (email: string) => {
    const encodedEmail = email.replaceAll(' ', '+');
    return encodedEmail;
};
